<template>
  <edit-field
      ref="EDIT_CURRENCY"
      :bold="bold"
      :context-id=contextId
      :data-table="dataTable"
      :disabled=readOnly
      :edit-field-info=editFieldInfo
      :hide-label="hideLabel"
      :max=max
      :min=min
      :required=required
      :single-line=true
      :value="value"
      @context=setInitValue
      @error=setError
      @updated=setUpdated>
  </edit-field>
</template>

<script lang="ts">
import EditBase from '@/framework/base/components/EditBase';
import EditField from '@/framework/base/components/EditField.vue';
import {EditFieldType, FieldInfo} from '@/framework/base/components/FieldInfo';
import validator, {Rule, rules, RULES_FRENCH_LABEL} from '@/generated/validators/ValidationRules';
import {FwkControls, RessourceFwkControl} from '@/ressources/globalRessources';
import {asciiLowerCase} from '@/framework/base/helpers/String';
import {defineComponent} from "vue";

export default defineComponent({
  components: {
    EditField
  },
  extends: EditBase,
  computed: {
    editFieldInfo(): FieldInfo {
      const precision = 2;
      const format = asciiLowerCase;
      const type = EditFieldType.IDENTIFIANT;
      const focus = this.focusValidator;
      const live = this.liveValidator;
      const mask = this.mask;
      const ressource = RessourceFwkControl(FwkControls.IDENTIFIANT);
      return new FieldInfo(ressource, type, precision, mask, format, focus, live, this.theme);
    }
  },
  methods: {
    isNumero(value: string): boolean {
      return /^0[0-9\s]*$/.test(value);
    },
    ignoreNumeroSpaces(rule: Rule): Rule {
      return {
        function: (value: string, param?: string[]) => rule.function(value.replace(/\s/g, ''), param),
        useMask: false
      };
    },
    mask(): string {
      return '';
    },
    focusValidator(value: string): validator | null {
      let res = null;
      if (value != "") {
        if (this.isNumero(value)) {
          res = new validator(this.ignoreNumeroSpaces(rules.numeroMobileValid), RULES_FRENCH_LABEL.text.numeroValid.error);
        } else {
          res = new validator(rules.emailFormat, RULES_FRENCH_LABEL.text.emailFormat.error);
        }
      }
      return res;
    },
    liveValidator(value: string): validator | null {
      let res = null;
      if (value != "") {
        if (this.isNumero(value)) {
          res = new validator(this.ignoreNumeroSpaces(rules.entier), RULES_FRENCH_LABEL.text.entier.error);
        } else {
          res = new validator(rules.emailLive, RULES_FRENCH_LABEL.text.emailLive.error);
        }
      }
      return res;
    },
    touch(): void {
      // @ts-expect-error : generated method
      this.$refs.EDIT_CURRENCY.touch();
    },
    setFocus(): void {
      // @ts-expect-error : generated method
      this.$refs.EDIT_CURRENCY.setFocus();
    },
    missing(): boolean {
      return this.required && (!this.value || this.value == '');
    }
  }
})

</script>
